import script from "./Forgot.vue?vue&type=script&setup=true&lang=js"
export * from "./Forgot.vue?vue&type=script&setup=true&lang=js"

import "./Forgot.vue?vue&type=style&index=0&id=08ef1042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ef1042"]])

export default __exports__